<template>
  <div class="source-block">
    <div class="source-tbl-head">
      <el-upload
        multiple
        action="https://upload.renrenjiang.cn/start"
        :show-file-list="false"
        accept=".mp3,.m4a,.wav,.aac"
        :before-upload="(file) => uploadFile(file)"
      >
        <el-button @click="showUploadDialog" type="primary" size="small">
          上传音频
        </el-button>
      </el-upload>
      <div class="head-right">
        <span class="head-text">上传时间：</span>
        <el-date-picker
          size="small"
          @change="changeDateRange"
          v-model="timerange"
          type="daterange"
          value-format="yyyy-MM-dd"
          class="head-datepicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-input
          @clear="reset"
          size="small"
          clearable
          v-model="params.keyword"
          class="head-keyword"
          placeholder="请输入素材名称"
        >
          <i
            @click="search"
            class="filter-search-icon el-icon-search el-input__icon"
            slot="suffix"
          ></i>
        </el-input>
      </div>
    </div>
    <div class="source-tbl-info">
      <div class="info-total">素材总量：{{ total }}</div>
      <div class="info-right">
        <el-dropdown @command="changeSort" class="info-dropdown">
          <div class="info-condition">
            <span v-if="params.sort_by === 'name_desc'">文件名称 (Z-A)</span>
            <span v-if="params.sort_by === 'name_asc'">文件名称 (A-Z)</span>
            <span v-if="params.sort_by === 'size_desc'">文件大小 (大-小)</span>
            <span v-if="params.sort_by === 'size_asc'">文件大小 (小-大)</span>
            <span v-if="params.sort_by === 'time_desc'">上传时间 (旧-新)</span>
            <span v-if="params.sort_by === 'time_asc'">上传时间 (新-旧)</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="name_asc">
              文件名称 (A-Z)
            </el-dropdown-item>
            <el-dropdown-item command="name_desc">
              文件名称 (Z-A)
            </el-dropdown-item>
            <el-dropdown-item command="size_desc">
              文件大小 (大-小)
            </el-dropdown-item>
            <el-dropdown-item command="size_asc">
              文件大小 (小-大)
            </el-dropdown-item>
            <el-dropdown-item command="time_asc">
              上传时间 (新-旧)
            </el-dropdown-item>
            <el-dropdown-item command="time_desc">
              上传时间 (旧-新)
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="source-tbl-block">
      <el-table
        v-if="showType === 'table'"
        :data="list"
        height="100%"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="音频" width="340">
          <template slot-scope="scope">
            <div class="audio-item">
              <div class="audio-item-cover">
                <el-image
                  fit="contain"
                  class="cover-img"
                  src="https://image.renrenjiang.cn/teacher_center/website/file/icon_file_new_mp3.png"
                ></el-image>
                <!-- <div class="cover-play"></div> -->
              </div>
              <div class="audio-item-info">
                <div class="audio-item-name">{{ scope.row.title }}</div>
                <div class="audio-item-dur">{{ scope.row.durationStr }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="大小">
          <template slot-scope="scope">
            {{ (scope.row.filesize * 1024).formatsize() }}
          </template>
        </el-table-column>
        <el-table-column label="上传时间">
          <template slot-scope="scope">
            <div>{{ new Date(scope.row.created_at).format("yyyy-MM-dd") }}</div>
            <div>{{ new Date(scope.row.created_at).format("HH:mm:ss") }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="上传者">
            <template slot-scope="scope">
              {{ scope.row.creator.nickname }}
            </template>
          </el-table-column>
          <el-table-column label="引用位置">
            <template>
              <el-button type="text">12</el-button>
            </template>
          </el-table-column> -->
        <el-table-column label="状态">
          <template>
            <div class="source-status">正常</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="增强保护">
            <template>-</template>
          </el-table-column> -->
        <el-table-column
          v-if="mode === 'normal'"
          label="操作"
          align="right"
          width="140"
        >
          <template slot-scope="scope">
            <el-button @click="editSource(scope.row)" type="text">
              编辑
            </el-button>
            <el-button @click="moveSource(scope.row)" type="text">
              移动
            </el-button>
            <!-- <el-button @click="deleteSource(scope.row)" type="text">
              删除
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="source-tbl-bottom">
      <div class="bottom-btns">
        <span class="bottom-text">
          已选 {{ selecteds.length }}/{{ list.length }} 条
        </span>
        <template v-if="mode === 'normal'">
          <!-- <el-button
            @click="batchDeleteSource"
            type="infor"
            size="small"
            :disabled="!selecteds.length"
          >
            批量删除
          </el-button> -->
          <el-button
            @click="batchMoveSource"
            type="infor"
            size="small"
            :disabled="!selecteds.length"
          >
            批量移动
          </el-button>
          <el-button
            @click="batchCreateSource"
            type="infor"
            size="small"
            :disabled="!selecteds.length"
          >
            批量创建课程
          </el-button>
          <!-- <el-button type="infor" size="small">批量下载</el-button> -->
          <el-button @click="moveAllSource" type="infor" size="small">
            全部移动
          </el-button>
        </template>
      </div>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="params.page"
        :page-size="params.pageSize"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog
      width="940px"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="uploadDialog.visible"
    >
      <div class="upload-dialog">
        <div class="dialog-head">
          <div class="dialog-head-title">上传音频</div>
          <div @click="closeUploadDialog" class="dialog-head-close"></div>
        </div>
        <div class="dialog-body padding flexed">
          <el-table :data="selectedFiles" height="100%" style="width: 100%">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column label="音频" width="340">
              <template slot-scope="scope">
                <div class="audio-item">
                  <div class="audio-item-cover">
                    <el-image
                      fit="contain"
                      class="cover-img"
                      src="https://image.renrenjiang.cn/teacher_center/website/file/icon_file_new_mp3.png"
                    ></el-image>
                  </div>
                  <div class="audio-item-info">
                    <div class="audio-item-name">{{ scope.row.name }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="大小">
              <template slot-scope="scope">
                {{ scope.row.size.formatsize() }}
              </template>
            </el-table-column>
            <el-table-column label="进度" min-width="150">
              <template slot-scope="scope">
                <div class="upload-progress">
                  <!-- <div class="upload-progress-bar">
                    <div class="bar-width"></div>
                  </div> -->
                  <el-progress
                    class="upload-progress-bar"
                    :show-text="false"
                    :percentage="scope.row.process - 0"
                  ></el-progress>
                  <div class="upload-progress-text">
                    {{ scope.row.process }}%
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 0">待上传</div>
                <div v-if="scope.row.status === 1">
                  正在上传
                  <i class="el-icon-loading"></i>
                </div>
                <div v-if="scope.row.status === 2">上传完成</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right" width="80">
              <template slot-scope="scope">
                <el-button @click="removeUploadItem(scope.row.id)" type="text">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dialog-foot">
          <!-- this.uploadDialog.status -->
          <template v-if="uploadDialog.status === 'show'">
            <el-upload
              multiple
              action="https://upload.renrenjiang.cn/start"
              :show-file-list="false"
              class="dialog-upload-btn"
              accept=".mp3,.m4a,.wav,.aac"
              :before-upload="(file) => uploadFile(file)"
            >
              <el-button size="small">添加音频</el-button>
            </el-upload>
            <el-button
              :disabled="selectedFiles.length === 0"
              @click="startUpload"
              type="primary"
              size="small"
            >
              上传
            </el-button>
          </template>
          <template v-if="uploadDialog.status === 'uploading'">
            <el-button :loading="true" size="small" type="primary">
              上传中…
            </el-button>
          </template>
          <template v-if="uploadDialog.status === 'finish'">
            <el-button @click="closeUploadDialog" size="small" type="primary">
              关闭
            </el-button>
          </template>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="420px"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="moveDialog.visible"
    >
      <div class="dialog-head">
        <div class="dialog-head-title">移动至</div>
        <div @click="closeMoveDialog" class="dialog-head-close"></div>
      </div>
      <div class="dialog-body padding">
        <el-select
          style="width: 100%"
          v-model="moveDialog.categoryId"
          placeholder="请选择素材分类"
          size="small"
        >
          <el-option
            v-for="(n, i) in moveDialog.categorys"
            :key="i"
            :value="n.id"
            :label="n.name"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-foot border">
        <el-button @click="closeMoveDialog" type="infor" size="small">
          取消
        </el-button>
        <el-button @click="moveConfirm" type="primary" size="small">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  updateCategoryVodSource,
  updateVodSource,
  deleteVodSource,
  getSourceCategorys,
} from "@/api/course";
import { getSources } from "@/api/api";
export default {
  data() {
    return {
      showType: "table",
      timerange: "",
      total: 0,
      list: [],
      params: {
        keyword: "",
        total: 1,
        page: 1,
        pageSize: 60,
        categoryId: "",
        sort_by: "time_desc",
      },
      uploadDialog: {
        visible: false,
        selecteds: [],
        status: "show",
      },
      selecteds: [],
      moveDialog: {
        visible: false,
        targets: [],
        categoryId: "",
        categorys: [],
        oldCategory: "",
      },
    };
  },
  props: {
    categoryId: {
      type: Number,
      default: null,
    },
    mode: {
      type: String,
      default: "normal",
    },
  },
  computed: {
    ...mapState("uploads", ["selectedFiles"]),
  },
  watch: {
    selecteds: {
      handler() {
        this.$emit("select", this.selecteds);
      },
      immediate: true,
      deep: true,
    },
    categoryId: {
      handler() {
        this.params.categoryId = this.categoryId;
        this.handleCurrentChange(1);
      },
      immediate: true,
      deep: 1,
    },
    selectedFiles: {
      handler() {
        if (this.selectedFiles.length === 0) {
          return (this.uploadDialog.status = "show");
        }

        if (this.uploadDialog.status === "uploading") {
          const file =
            this.selectedFiles.length > 0 &&
            this.selectedFiles.filter((item) => item.status === 0);
          if (file.length === 0) {
            this.uploadDialog.status = "finish";
          }
        }
      },
      deep: 1,
    },
  },
  mounted() {
    this.params.categoryId = this.categoryId;
    this.loadData();
  },
  methods: {
    batchCreateSource() {
      let key = this.$rrj.uuid();
      this.$rrj.storage.set(key, this.selecteds);
      this.$router.push({
        path: "/content/audio/batch",
        query: {
          key,
        },
      });
    },
    changeDateRange() {
      if (this.timerange) {
        this.params.start_at = this.timerange[0] + " 00:00:00";
        this.params.end_at = this.timerange[1] + " 23:59:59";
      } else {
        delete this.params.start_at;
        delete this.params.end_at;
      }
      this.handleCurrentChange(1);
      console.log("this.timerange", this.timerange);
    },
    async moveAllSource() {
      let res = await getSourceCategorys("audio");
      this.moveDialog = {
        visible: true,
        targets: [],
        categoryId: "",
        categorys: res.data,
        oldCategory: this.categoryId,
      };
    },
    editSource(source) {
      this.$prompt("请输入素材名称", "编辑素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: source.file_name,
      })
        .then(async ({ value }) => {
          console.log(value);
          const res = await updateVodSource(source.video_id, {
            file_name: value,
          });
          if (res.result === "ok") {
            this.loadData();
            this.$message.success("操作成功");
          } else {
            this.$message.success("操作失败");
          }
        })
        .catch(() => {});
    },
    async moveSource(source) {
      let res = await getSourceCategorys("audio");
      this.moveDialog = {
        visible: true,
        targets: [source],
        categoryId: "",
        categorys: res.data,
        oldCategory: "",
      };
    },
    async batchMoveSource() {
      let res = await getSourceCategorys("audio");
      this.moveDialog = {
        visible: true,
        targets: this.selecteds,
        categoryId: "",
        categorys: res.data,
        oldCategory: "",
      };
    },
    async moveConfirm() {
      if (this.moveDialog.targets.length === 0 && this.moveDialog.oldCategory) {
        await updateCategoryVodSource(this.moveDialog.oldCategory, {
          categoryId: this.moveDialog.categoryId,
        });
      } else {
        for (let source of this.moveDialog.targets) {
          await updateVodSource(source.video_id, {
            category_id: this.moveDialog.categoryId,
          });
        }
      }

      this.loadData();
      this.$message.success("操作成功");
      this.closeMoveDialog();
      this.$bus.$emit("refreshSourceCategory");
    },
    closeMoveDialog() {
      this.moveDialog.visible = false;
      this.moveDialog.categoryId = "";
      this.moveDialog.oldCategory = "";
    },
    batchDeleteSource() {
      this.$confirm("确认要删除所选素材吗？", "删除素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          for (let source of this.selecteds) {
            await deleteVodSource(source.video_id);
          }
          this.loadData();
          this.$message.success("操作成功");
        })
        .catch(() => {});
    },
    deleteSource(source) {
      this.$confirm("确认要删除这个素材吗？", "删除素材", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const res = await deleteVodSource(source.video_id);
          if (res.result === "ok") {
            this.loadData();
            this.$message.success("操作成功");
          } else {
            this.$message.success("操作失败");
          }
        })
        .catch(() => {});
    },
    handleSelectionChange(res) {
      this.selecteds = this.$rrj.deepClone(res);
    },
    changeShowType(type) {
      this.showType = type;
    },
    closeUploadDialog() {
      if (this.uploadDialog.status === "uploading") {
        this.$message.error("正在上传中，请稍后关闭");
        return;
      }
      this.uploadDialog = {
        visible: false,
        selecteds: [],
        status: "show",
      };
      this.loadData();
    },
    showUploadDialog() {
      this.uploadDialog = {
        visible: true,
        selecteds: [],
        status: "show",
      };
      console.log("showUploadDialog");
      this.$store.commit("uploads/setSelectedFiles", []);
    },
    // closeUpload() {
    //   this.closeUploadDialog();
    // },
    removeUploadItem(id) {
      this.$store.dispatch("uploads/cancelUpload", id);
    },
    async startUpload() {
      this.uploadDialog.status = "uploading";
      for (const item of this.selectedFiles) {
        this.$store.dispatch("uploads/createUpload", {
          file: item.file,
          id: item.id,
        });
      }
    },
    async uploadFile(file) {
      // let url = await file.getBlob();
      // console.log("file", url, file);
      const parts = file.name.split(".");
      // 返回数组的最后一个元素作为后缀
      let suffix = parts[parts.length - 1];
      // this.uploadDialog.selecteds.push({
      //   name: file.name,
      //   file,
      //   status: 0,
      //   suffix: suffix,
      //   size: file.size,
      // });

      file.categoryId = this.categoryId;
      this.$store.commit("uploads/addFiles", [
        {
          name: file.name,
          file,
          status: 0,
          suffix: suffix,
          size: file.size,
        },
      ]);
    },
    changeSort(sortBy) {
      this.params.sort_by = sortBy;
      this.handleCurrentChange(1);
    },
    search() {
      this.handleCurrentChange(1);
    },
    reset() {
      delete this.params.keyword;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(current) {
      this.params.page = current;
      this.loadData();
    },
    async loadData() {
      let res = await getSources("audio", this.params);
      for (let item of res.rows) {
        const hours = Math.floor(item.duration / 3600);
        const minutes = Math.floor((item.duration % 3600) / 60);
        const seconds = item.duration % 60;
        item.durationStr = `${hours < 10 ? "0" + hours : hours}:${
          minutes < 10 ? "0" + minutes : minutes
        }:${seconds < 10 ? "0" + seconds : seconds}`;
      }
      this.list = res.rows;
      this.total = res.totalCount;
      console.log(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-item {
  width: 320px;
  display: flex;
  align-items: center;

  .audio-item-cover {
    width: 40px;
    height: 40px;
    position: relative;

    .cover-img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
    }

    .cover-play {
      width: 24px;
      height: 24px;
      cursor: pointer;

      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 50%;
      background-size: 100%;
      transform: translate(-50%, -50%);
      background-color: rgba($color: #000000, $alpha: 0.4);
      background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_source_video_play_ico.png);

      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.9);
      }
    }
  }

  .audio-item-info {
    width: 0;
    flex-grow: 1;
    margin-left: 10px;

    .audio-item-name {
      width: 100%;
      max-height: 40px;
      line-height: 20px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .audio-item-dur {
      font-size: 12px;
      color: #8a9099;
    }
  }
}

.upload-dialog {
  width: 100%;
  height: 70vh;
  border-radius: 16px;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;
}

.upload-progress {
  display: flex;
  align-items: center;

  .upload-progress-bar {
    width: 100px;
    height: 8px;
    border-radius: 4px;
    // background-color: #dfe2e5;

    // .bar-width {
    //   width: 10%;
    //   height: 8px;
    //   border-radius: 4px;
    //   background-color: #0366ff;
    // }
  }

  .upload-progress-text {
    margin-left: 8px;
    line-height: 20px;
    font-size: 12px;
  }
}

.dialog-upload-btn {
  margin-right: 10px;
}
</style>
